"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TournamentForSignUp = /** @class */ (function () {
    function TournamentForSignUp() {
    }
    return TournamentForSignUp;
}());
exports.default = TournamentForSignUp;
